<div>
  <mic-breadcrumb id="email-setup-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') || 'Setup' }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/emailSetup"
      label="{{ translationService.translate('emailSetupText') || 'Email Setup' }}"
    ></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="email-setup-heading">
    {{ translationService.translate('emailSetupText') || 'Email Setup' }}
  </h2>

  <div class="container">
    <form [formGroup]="filterForm" class="mt-4">
      <mat-card class="search-card mt-3">
        <div class="filters flex flex-row justify-between items-start sm-flex-col gap-4 email-setup-filters">
          <div class="flex flex-row gap-4 email-setup-fields">
            <div class="filter-field col-auto">
              <app-dropdown-search-single-select
                id="nameFilterDropdown"
                label="{{ translationService.translate('nameText') || 'Name' }}"
                emptyPlaceholder="{{ translationService.translate('searchByNameText') || 'Search by Name' }}"
                placeholder="{{ translationService.translate('searchByNameText') || 'Search by Name' }}"
                [formGroup]="filterForm"
                formControlName="names"
                [data]="nameFilterList"
              >
              </app-dropdown-search-single-select>
            </div>
            <div class="filter-field col-auto">
              <app-dropdown-search-single-select
                id="emailFilterDropdown"
                label="{{ translationService.translate('emailText') || 'Email' }}"
                emptyPlaceholder="{{ translationService.translate('selectEmailText') || 'Select Email' }}"
                placeholder="{{ translationService.translate('selectEmailText') || 'Select Email' }}"
                [formGroup]="filterForm"
                formControlName="emails"
                [data]="emailFilterList"
              >
              </app-dropdown-search-single-select>
            </div>
            <div class="filter-field col-auto">
              <app-dropdown-search-single-select
                id="typeFilterDropdown"
                label="{{ translationService.translate('emailTypeFilterText') || 'Type' }}"
                emptyPlaceholder="{{ translationService.translate('selectTypeFilterText') || 'Select Type' }}"
                placeholder="{{ translationService.translate('selectTypeFilterText') || 'Select Type' }}"
                [formGroup]="filterForm"
                formControlName="types"
                [data]="typeFilterList"
              >
              </app-dropdown-search-single-select>
            </div>
          </div>
          <div class="flex flex-row flex-1 gap-4 justify-end email-setup-actions">
            <button
              id="reset-filters"
              type="button"
              mat-flat-button
              color="accent"
              (click)="resetFilters()"
              class="mic-btn-icon-left btn-clear"
            >
              <mat-icon>refresh</mat-icon>
              {{ translationService.translate('clearSelectionText') || 'Clear Filter' }}
            </button>
            <button
              id="add-email-setup"
              type="button"
              mat-flat-button
              color="primary"
              class="mic-btn-icon-left btn-primary"
              (click)="addRow()"
              [disabled]="!canEdit"
              matTooltip="{{
                !canEdit
                  ? translationService.translate('addDisabledText') || 'Add disabled'
                  : translationService.translate('addEmailText') || 'Add Email'
              }}"
            >
              <mat-icon>add</mat-icon>
              {{ translationService.translate('addEmailText') || '+ Add Email' }}
            </button>
          </div>
        </div>
      </mat-card>
    </form>

    <div id="email-setup-table" class="cam-table mt-2">
      <mic-table #paginatedTable class="table-stripped btn-table" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state
            icon="layers_clear"
            title="{{ translationService.translate('emptyTableText') || 'No data available' }}"
          ></mic-empty-state>
        </ng-container>

        <!-- Type Column -->
        <ng-container *micCellTemplate="let item; name: 'type'">
          @if (isEditing(item)) {
          <mat-form-field appearance="fill" class="cell-field edit-component">
            <mat-select
              [formControl]="getControl(item, 'type')"
              placeholder="{{ translationService.translate('selectTypeText') || 'Select' }}"
              (selectionChange)="onTypeChange(item)"
            >
              @for (opt of typeOptions; track opt) {
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @else {
          <span>{{ item.type }}</span>
          }
        </ng-container>

        <!-- Name Column -->
        <ng-container *micCellTemplate="let item; name: 'name'">
          @if (isEditing(item)) {
          <mat-form-field appearance="fill" class="cell-field edit-component">
            <input matInput type="text" maxlength="60" [formControl]="getControl(item, 'name')" />
          </mat-form-field>
          } @else {
          <span>{{ item.name }}</span>
          }
        </ng-container>

        <!-- Email Column -->
        <ng-container *micCellTemplate="let item; name: 'email'">
          @if (isEditing(item)) {
          <mat-form-field appearance="fill" class="cell-field edit-component">
            <input matInput type="email" maxlength="60" [formControl]="getControl(item, 'email')" />
          </mat-form-field>
          } @else {
          <span>{{ item.email }}</span>
          }
        </ng-container>

        <!-- Location Column (Type in the screenshot) -->
        <ng-container *micCellTemplate="let item; name: 'location'">
          @if (isEditing(item)) {
          <mat-form-field appearance="fill" class="cell-field edit-component">
            <mat-select
              [formControl]="getControl(item, 'location')"
              placeholder="{{ translationService.translate('selectLocationText') || 'Select' }}"
            >
              @for (opt of getLocationOptionsForRow(item); track opt.value) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @else {
          <span>{{ getLocationLabel(item) }}</span>
          }
        </ng-container>

        <!-- Action Column -->
        <ng-container *micCellTemplate="let item; name: 'action'">
          @if (isEditing(item)) {
          <button
            mat-icon-button
            (click)="saveRow(item)"
            [disabled]="!canEdit"
            [class.disabled-icon]="!canEdit"
            matTooltip="{{
              !canEdit
                ? translationService.translate('saveDisabledText') || 'Save disabled'
                : translationService.translate('saveLinkText') || 'Save'
            }}"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button mat-icon-button (click)="cancelEdit(item)" matTooltip="{{ translationService.translate('cancelText') || 'Cancel' }}">
            <mat-icon>cancel</mat-icon>
          </button>
          } @else {
          <button
            mat-icon-button
            class="btn-delete"
            (click)="showDeleteModal(item)"
            [disabled]="!canEdit"
            matTooltip="{{
              !canEdit
                ? translationService.translate('deleteDisabledText') || 'Delete disabled'
                : translationService.translate('deleteText') || 'Delete'
            }}"
          >
            <mat-icon>delete_outline</mat-icon>
          </button>
          <button
            mat-icon-button
            (click)="startEdit(item)"
            [disabled]="!canEdit"
            [class.disabled-icon]="!canEdit"
            matTooltip="{{
              !canEdit
                ? translationService.translate('editDisabledText') || 'Edit disabled'
                : translationService.translate('editText') || 'Edit'
            }}"
          >
            <mat-icon>edit</mat-icon>
          </button>
          }
        </ng-container>
      </mic-table>
    </div>

    <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
    <ng-template #deleteContent>{{
      translationService.translate('deleteEmailSetupConfirmText') || 'Are you sure you want to delete this email setup?'
    }}</ng-template>
    <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
    <ng-template #discardContent>{{
      translationService.translate('unSaveChangesText') || 'You have unsaved changes. Do you want to discard them?'
    }}</ng-template>
  </div>
</div>
